import { localeNumber } from '@hotjar/insights-common/lib/number';

export const cappedLocaleNumber = (input: string | number, capValue: number): string | number => {
  const number = typeof input === 'string' ? parseInt(input, 10) : input;
  if (isNaN(number)) {
    return input;
  }

  if (number >= capValue) {
    return localeNumber(capValue) + '+';
  }

  return localeNumber(number) ?? 0;
};
